import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-student-courses-and-time-table-calendar-block-list',
  templateUrl: './student-courses-and-time-table-calendar-block-list.component.html',
  styleUrls: ['./student-courses-and-time-table-calendar-block-list.component.scss']
})
export class StudentCoursesAndTimeTableCalendarBlockListComponent {
  @Input() data: any;
}
